import { render, staticRenderFns } from "./aRestaurantSalesChart.vue?vue&type=template&id=55cc07f1"
import script from "./aRestaurantSalesChart.vue?vue&type=script&lang=js"
export * from "./aRestaurantSalesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports